import ZoomIn from '../../src/legacy/ZoomIn.tsx';
export default ZoomIn;
